<template>
    <div class="user-layout">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'UserLayout',
};
</script>

<style scoped>
.user-layout {
    min-height: 100vh;
    background-color: #ffffff;
}
</style>
